import {observable, action} from "mobx"
import {v4 as uuidv4} from "uuid"
import api from "../../global/actions/api"
import {getUserCompanyInfo} from "../../global/helpers/actions"
import GlobalStore from "../../global/store/GlobalStore"
import InfoStore from "../../global/store/InfoStore"
import DeviceDialogStore from "./DeviceDialogStore"
import ConsentDialogStore from "./ConsentDialogStore"
import moment from "moment"
import WarningDialogStore from "./WarningDialogStore"

class RequestFormStore {
	@observable applicantChipForm = []
	@observable locationChipForm = []
	@observable roundsData = []
	@observable callId = null
	@observable callCode = null
	@observable dropedFiles0 = []
	@observable dropedFiles1 = []
	@observable dropedFiles2 = []
	@observable dropedFiles3 = []
	@observable dropedFiles4 = []
	@observable dropedFiles5 = []
	@observable dropedFiles6 = []
	@observable attachmentTemplates = [
		"GD:GDREQ:ENERGETICAUDIT",
		"GD:GDREQ:OZE",
		"GD:GDREQ:MINIMALDECLARATION",
		"GD:GDREQ:DIVISIONACTIVITY",
		"GD:GDREQ:POWEROFATTORNEY",
		"GD:GDREQ:AFFIDAVIT"
	]

	@observable readonlyForm = false
	@observable showSwift = false
	@observable showEditButton = false
	@observable requestInProgress = false

	formRef = null

	defaultFormValues = {}

	@action getRounds() {
		api
			.getRounds()
			.call()
			.then((rounds) => {
				if (isSafe(rounds)) {
					this.roundsData = rounds.rows.map((round) => ({
						_id: round.round_id,
						code_ext: round.round_id,
						region_type_id: round.region_type_id,
						name_ext: `${round.region_type_code_ext} + ${round.devide_group_name_ext} ${moment(
							round.validity_from
						).format("DD.MM.YYYY")} - ${moment(round.validity_to).format("DD.MM.YYYY")}`
					}))
				} else {
					this.roundsData = []
				}
			})
	}

	@action isSameFormValues() {
		return JSON.stringify(this.defaultFormValues) === JSON.stringify(this.formRef.values())
	}

	@action deleteLoadedAttachemnt(id, dropzoneIndex, attachmentIndex) {
		let data = {
			_id: id,
			active: false
		}
		api
			.saveAttachment(data)
			.call()
			.then(() => {
				this[`dropedFiles${dropzoneIndex}`].splice(attachmentIndex, 1)
			})
	}

	@action resetDropzones() {
		this.dropedFiles0 = []
		this.dropedFiles1 = []
		this.dropedFiles2 = []
		this.dropedFiles3 = []
		this.dropedFiles4 = []
		this.dropedFiles5 = []
		this.dropedFiles6 = []
	}

	generateDataAndSave(form, callback) {
		let droppedFiles = [
			...this.dropedFiles0,
			...this.dropedFiles1,
			...this.dropedFiles2,
			...this.dropedFiles3,
			...this.dropedFiles4,
			...this.dropedFiles5,
			...this.dropedFiles6
		]
		if (isSafe(droppedFiles) && droppedFiles.length) {
			let req = []
			let files = droppedFiles
			var saveFunction = this.save

			let binaryDataArr = []
			let getdata = function(index) {
				let data = files[index]
				if (isEmpty(data._id)) {
					let binaryData

					var reader = new FileReader()
					reader.readAsBinaryString(data)

					reader.onloadend = function() {
						binaryData = reader.result
						binaryDataArr.push(binaryData)
						req.push({
							attachment_id: isNotEmpty(data._id) ? data._id : null,
							_ref: false,
							active: true,
							content_type: isNotEmpty(data.type) ? data.type : "application/octet-stream",
							// content: binaryData.split(",")[1], ???
							content: btoa(binaryData),
							type: data.templateName,
							file_name: data.name,
							size: data.size
						})
						if (files.length > index + 1) {
							getdata(index + 1)
						} else {
							saveFunction(form, req, callback)
						}
					}
				} else {
					req.push({
						attachment_id: data._id,
						file_name: data.name,
						type: data.databaseType,
						content_type: isNotEmpty(data.type) ? data.type : "application/pdf",
						_ref: false,
						active: true
					})

					if (files.length > index + 1) {
						getdata(index + 1)
					} else {
						saveFunction(form, req, callback)
					}
				}
			}
			getdata(0)
		} else {
			this.save(form, [], callback)
		}
	}

	@action save(form, dropzoneData, callback) {
		GlobalStore.loading(true)
		const formVals = form.values()

		let req = {
			record_id: isNotEmpty(formVals.request_id) ? formVals.request_id : null, // vyplnaj pri UPDATE
			_type: "GD.API.JSON.Proxy.Request.GDRequest",
			status_id: formVals.status,
			type_id: "GD.Data.Request.GDRequest",
			attached_files: dropzoneData,
			company_data: {
				company: getUserCompanyInfo().company_id,
				tax_identification_number: formVals.dic,
				vat_identification_number: formVals.icdph,
				legal_form_id: formVals.companyLegalForm, //(Entity.CL.LegalForm)
				iban: formVals.companyIBAN,
				swift: formVals.companySWIFT,
				communication_method: formVals.methodOfCommunication,
				company_size_id: formVals.companySize,
				classification_id: formVals.skNace,
				oa_address: {
					obj_city: {
						_type: "Entity.CL.Address.City",
						_id: formVals.companyCity
					},
					primary: true,
					street_plain: formVals.companyStreet.trim(),
					type: {
						_type: "Entity.CL.AddressType",
						_id: "OA"
					}
				}
			},
			project_implementations_data: [],
			statutories_data: [],
			round_data: isNotEmpty(formVals.round_id) ? {round_id: formVals.round_id} : null,
			request_for_ea_grant: formVals.contributionForEnergyAudit,
			expected_voucher_amount: formVals.expected_voucher_amount,
			consent_personal_data_processing: formVals.consent
		}

		//Devices
		if (DeviceDialogStore.places.length > 0) {
			const projectData = DeviceDialogStore.places.map((plc) => {
				const place = {
					city_id: plc.cityId,
					street_plain: plc.street,
					devices_data: []
				}

				plc.devices.forEach((device) => {
					const deviceObj = {
						device_id: device.deviceId,
						power: device.power
					}

					if (isNotEmpty(device.catastral)) {
						deviceObj["cadastral_name"] = device.catastral
					}

					if (isNotEmpty(device.capacity)) {
						deviceObj["accumulation_capacity"] = device.capacity
					}

					if (isNotEmpty(device.parcel)) {
						deviceObj["lot_number"] = device.parcel
					}

					place.devices_data.push(deviceObj)
				})

				return place
			})

			req.project_implementations_data = projectData
		}

		//Kontaktna osoba
		if (
			isNotEmpty(formVals.contactPersonName) ||
			isNotEmpty(formVals.contactPersonMail) ||
			isNotEmpty(formVals.contactPersonPhone)
		) {
			req["request_contact_data"] = {
				name: formVals.contactPersonName,
				email: formVals.contactPersonMail,
				phone: formVals.contactPersonPhone.replace(/\s/g, "")
			}
		}

		if (
			isNotEmpty(formVals.authorizedPersonName) ||
			isNotEmpty(formVals.authorizedPersonMail) ||
			isNotEmpty(formVals.authorizedPersonPhone)
		) {
			req["empowered_contact_data"] = {
				name: formVals.authorizedPersonName,
				email: formVals.authorizedPersonMail,
				phone: formVals.authorizedPersonPhone.replace(/\s/g, "")
			}
		} else {
			req["empowered_contact_data"] = null
		}

		//Owners data
		if (isNotEmpty(formVals.numberOfOwners) && formVals.numberOfOwners > 0) {
			req["owners_data"] = []

			for (let i = 1; i <= formVals.numberOfOwners; i++) {
				if (isEmpty(formVals[`rpo_search_${i}`])) {
					req["owners_data"].push({
						company_name: "",
						company_identifier: "",
						person_name: formVals[`ownerName_${i}`],
						ownership_share: formVals[`ownershipInterest_${i}`]
					})
				} else {
					req["owners_data"].push({
						company_name: formVals[`rpo_search_name_${i}`],
						company_identifier: formVals[`rpo_search_${i}`],
						person_name: "",
						ownership_share: formVals[`ownershipInterest_${i}`]
					})
				}
			}
		}

		//Statutari
		let statutarData = isEmpty(formVals.applicantChipForm) ? [] : JSON.parse(formVals.applicantChipForm)
		statutarData.map((statutar) => {
			req["statutories_data"].push(statutar.name)
		})

		api
			.saveRequest(req)
			.call()
			.then((response) => {
				if (isNotEmpty(response.WarningMessage)) {
					WarningDialogStore.open(response.WarningMessage)
				} else {
					GlobalStore.setNotificationMessage(
						formVals.status === "inp" ? "Uloženie prebehlo úspešne" : "Odoslanie prebehlo úspešne",
						"",
						"success"
					)
				}

				DeviceDialogStore.places = []
				if (isSafe(callback)) {
					callback(response._id)
				}
			})
			.catch(() => {
				ConsentDialogStore.close(form)
			})
	}

	@action load(form, id) {
		GlobalStore.loading(true)
		api
			.loadRequestWithAtt(id)
			.call()
			.then((response) => {
				form.reset()
				const company = response.company_data || {}
				const request_contact_data = response.request_contact_data || {}
				const companyAddresses = company.oa_address || {}
				const empowered_contact_data = response.empowered_contact_data || {}

				let startBy = 0

				if (isNotEmpty(response.start) && moment(moment()).isBefore(response.start, "second")) {
					startBy = Math.abs(moment().diff(moment(response.start)))
				}

				let formObj = {
					request_id: response.record_id,
					gd_request_id: response.gd_request_id,
					status: response.status_id,
					dic: company.tax_identification_number,
					ico: company.identifier,
					icdph: company.vat_identification_number,
					companyName: company.name,
					companySize: company.company_size_id,
					companyStreet: companyAddresses.street_plain,
					companyCity: companyAddresses.obj_city,
					companyLegalForm: company.legal_form_id,
					companyIBAN: company.iban,
					companySWIFT: company.swift,
					communicationMethod: company.communication_method ? "electronicCommunication" : "writtenCommunication",
					contactPersonName: request_contact_data.name,
					contactPersonMail: request_contact_data.email,
					contactPersonPhone: request_contact_data.phone,
					skNace: company.classification_id,
					authorizedPersonMail: empowered_contact_data.email,
					authorizedPersonName: empowered_contact_data.name,
					authorizedPersonPhone: empowered_contact_data.phone,
					round_id: isSafe(response.round_data) ? response.round_data.round_id : null,
					expected_voucher_amount: response.expected_voucher_amount,
					contributionForEnergyAudit: response.request_for_ea_grant,
					methodOfCommunication: company.communication_method,
					start: response.start,
					startBy: startBy
				}

				if (isSafe(response.round_data)) {
					const round = response.round_data

					formObj.round_text = `${round.region_type_code_ext} + ${round.devide_group_name_ext} ${moment(
						round.validity_from
					).format("DD.MM.YYYY")} - ${moment(round.validity_to).format("DD.MM.YYYY")}`
				}

				if (isSafe(response.owners_data) && response.owners_data.length > 0) {
					formObj.numberOfOwners = response.owners_data.length

					response.owners_data.forEach((owner, index) => {
						if (isNotEmpty(owner.company_identifier)) {
							formObj[`rpo_search_${index + 1}`] = owner.company_identifier
							formObj[`rpo_search_name_${index + 1}`] = owner.company_name
						} else {
							formObj[`ownerName_${index + 1}`] = owner.person_name
						}
						formObj[`ownershipInterest_${index + 1}`] = owner.ownership_share
					})
				}

				this.showSwift = isNotEmpty(company.swift) ? true : false
				this.showEditButton = response.status_id === "inp"
				this.requestInProgress = response.status_id === "inp"

				if (isSafe(response.statutories_data) && response.statutories_data.length > 0) {
					let statutors = []
					response.statutories_data.forEach((statutar) => {
						statutors.push({
							name: statutar
						})
					})
					formObj.applicantChipForm = JSON.stringify(statutors)
				} else {
					formObj.applicantChipForm = JSON.stringify([{name: ""}])
				}

				if (isSafe(response.project_implementations_data) && response.project_implementations_data.length > 0) {
					const places = []

					response.project_implementations_data.forEach((place) => {
						const placeObj = {
							cityId: place.city_id,
							city: place.city_with_county, //TODO: city_name BE
							street: place.street_plain,
							devices: []
						}

						place.devices_data.forEach((device) => {
							placeObj.devices.push({
								_id: uuidv4(),
								deviceId: device.device_id,
								device: device.device_name_ext,
								deviceCode: device.device_code,
								power: device.power,
								capacity: device.accumulation_capacity,
								catastral: device.cadastral_name,
								parcel: device.lot_number
							})
						})

						places.push(placeObj)
					})

					DeviceDialogStore.places = places
				}

				if (isSafe(response.attached_files) && response.attached_files.length) {
					response.attached_files.forEach((attachment) => {
						// const blob = b64toBlob(attachment.content)
						let tmp = {}
						// new Blob([blob], {
						// 	type: attachment.content_type
						// })
						tmp.name = attachment.file_name
						tmp.size = attachment.size
						tmp._id = attachment.attachment_id
						tmp.databaseType = attachment.type
						if (attachment.type === "GD:GDREQ:ENERGETICAUDIT") {
							this.dropedFiles0.push(tmp)
						}
						if (attachment.type === "GD:GDREQ:OZE") {
							this.dropedFiles1.push(tmp)
						}
						if (attachment.type === "GD:GDREQ:MINIMALDECLARATION") {
							this.dropedFiles2.push(tmp)
						}
						if (attachment.type === "GD:GDREQ:DIVISIONACTIVITY") {
							this.dropedFiles3.push(tmp)
						}
						if (attachment.type === "GD:GDREQ:POWEROFATTORNEY") {
							this.dropedFiles4.push(tmp)
						}
						if (attachment.type === "GD:GDREQ:AFFIDAVIT") {
							this.dropedFiles5.push(tmp)
						}
					})
				}

				form.set(formObj)

				this.defaultFormValues = form.values()

				GlobalStore.loading(false)
			})
	}

	downloadSpiecificTemplate(uri, name) {
		api.downloadFile(uri, name)
	}

	validateDraft(form, callback) {
		const formVals = form.values()

		//Polia ktore su req pri drafte
		if (
			isEmpty(formVals.companyName) ||
			isEmpty(formVals.companyLegalForm) ||
			isEmpty(formVals.companyCity) ||
			isEmpty(formVals.companyStreet) ||
			isEmpty(formVals.dic) ||
			isEmpty(formVals.icdph) ||
			isEmpty(formVals.companyIBAN)
		) {
			GlobalStore.setNotificationMessage(
				`Polia "Obchodné meno", Oprávnená oblasť, Základná charakteristika Žiadateľa", "Právna forma", "Obec", "Kraj", "Ulica", "Popisné číslo", "PSČ" sú povinné pre uloženie rozpracovanei verzie`,
				null,
				"error"
			)
		} else {
			callback()
		}
	}

	async loadCodelistAndForm(form, id) {
		GlobalStore.loading(true)
		this.load(form, id)
	}

	handleFormForIpceiRequest(form) {
		form.$("projectName").value = "Dokumentácia pre notifikačný proces IPCEI"
	}

	loadCompanyInfo(form) {
		GlobalStore.loading(true)
		const id = getUserCompanyInfo().company_id
		api
			.loadCompanyInfo(id)
			.call()
			.then((company) => {
				form.$("companyName").value = company.name
				form.$("ico").value = company.identifier
				form.$("companyDesc").value = isSafe(company.type) ? company.type.code : ""
				form.$("companyLegalForm").value = isSafe(company.legal_form) ? company.legal_form.code : ""
				form.$("dic").value = company.tax_identification_number
				form.$("icdph").value = company.vat_identification_number
				let orgunit = company.specific_rels.find((row) => row._type == "INN.Data.Entity.OrgUnit")
				if (isSafe(orgunit) && isSafe(orgunit.addresses)) {
					let address = orgunit.addresses.find(
						(row) => row._type == "Entity.Data.Address" && row.active == true && row.type._id == "OA"
					)
					if (isSafe(address)) {
						form.$("companyRegion").value = isSafe(address.region) ? address.region._id : ""
						form.$("companyCity").value = isSafe(address.obj_city) ? address.obj_city._id : ""
						form.$("companyStreet").value = address.street_plain
						form.$("companyStreetNumber").value = address.house_number
						form.$("companyPSC").value = address.zip_plain
					}

					let account = orgunit.accounts.find((row) => row._type == "Fin.Data.BankAccount")
					if (isSafe(account)) {
						form.$("companyIBAN").value = account.number
					}
				}

				this.checkRegionAvailability(form)
				GlobalStore.loading(false)
			})
			.catch(() => {
				GlobalStore.loading(false)
			})
	}

	checkRegionAvailability(form) {
		const {callId, companyRegion} = form.values()
		if (isNotEmpty(callId) && isNotEmpty(companyRegion)) {
			const req = {
				region_id: companyRegion,
				call_id: callId
			}

			api
				.regionRestriction(req)
				.call()
				.then((response) => {
					if (
						(isSafe(response) && response.CallValidityIsNow == 0) ||
						(isSafe(response) &&
							isSafe(response.Regions) &&
							isSafe(response.Regions[0]) &&
							response.Regions[0].ValidityIsNow == 0)
					) {
						InfoStore.open(
							"Aktuálne nie je možné podať ŽoIP so sídlom podnikania v rámci Vášho kraja. Viac informácií je dostupných v rámci oznámenia zverejnenom na webovom sídle www.siea.sk/inovacie/inovacnepoukazky/ .",
							"Upozornenie"
						)
					}
				})
		}
	}
}

var singleton = new RequestFormStore()
export default singleton

